import React, { useState, useEffect } from 'react';
import produce from 'immer';

const useQueue = (queueLength) => {
  const [queue, setQueue] = useState(queueLength);
  const [hasFinish, setHasFinish] = useState(false);

  const add = (item) => {
    const newQueue = produce(queue, (draft) => {
      if (!draft.find((q) => q.id === item.id)) draft.push(item);

      return draft;
    });

    setQueue(newQueue);
  };
  const update = (item) => {
    const newQueue = produce(queue, (draft) => {
      const updateQueue = draft.find((q) => q.id === item.id);

      updateQueue.trigger = item.trigger;

      return draft;
    });

    setQueue(newQueue);
  };

  const reset = () => {
    setQueue([]);
  };
  const remove = (id) => {
    const newQueue = produce(queue, (draft) => {
      draft = draft.filter((q) => q.id !== id);

      return draft;
    });

    setQueue(newQueue);
  };

  useEffect(() => {
    if (queue.length > 0 && queue.every((q) => !!q.trigger)) {
      setHasFinish(true);
      reset();
    }
  }, [queue]);

  return [add, remove, hasFinish, setHasFinish, update, reset];
};

export default useQueue;
